import { assetBaseURL } from 'app/config/client';
import SharedConfig from '../../config/shared.json';

export const CMAPS_PATH = `${assetBaseURL}${SharedConfig.pdfjsCmapsPath}`;
